<template>
	<article class="article article--reference" role="article">
		<div class="article__image":style="{ 'background-image': 'url(' + images[0].url + ')' }"
			@click="index = 0, $emit('open-gallery')">
			<div class="article__term">
				<img :src="termImage.url" :alt="termImage.alt">
			</div>
		</div>

		<div class="article__content">
			<h3 @click="index = 0, $emit('open-gallery')">{{referenceTitle}}</h3>
			<slot></slot>
			<div class="gallery gallery--reference">
				<div class="gallery__item"
					 v-for="(image, key) in images.slice(1)"
					 :class="{'gallery__item--hidden': key > 4}"
					 @click="index = key + 1, $emit('open-gallery'), $root.galleryOpen = true">
					<figure class="frame"
							v-lazy:background-image="image.thumbnail">
					</figure>
				</div>
			</div>
		</div>
		<LightGallery
				:images="images"
				:index="index"
				:disable-scroll="true"
				@close="index = null, $emit('close-gallery'), $root.galleryOpen = false"
		/>
	</article>
</template>

<script>
	import { LightGallery } from 'vue-light-gallery';

	export default {
		name: 'VueReference',

		props: {
			images: {
				type: Array,
			},

			termImage: {
				required: true,
			},

			referenceTitle: {
				required: true,
			},
		},

		components: {
			LightGallery,
		},

		data() {
			return {
				index: null,
			}
		},

		methods: {
			test(id) {
				console.log(id);
			}
		}
	};
</script>

<style>
	.light-gallery__text {
		white-space: normal;
	}
</style>